import { SysNotiIcon } from './imgs/SysNoti';
import { NewOnlineIcon } from './imgs/NewOnline';
import { HotActiIcon } from './imgs/HotActi';
import { ImpNotiIcon } from './imgs/ImpNoti';

export const iconMap = {
  1: {
    Icon: SysNotiIcon,
    labelKey: 'user.system',
  },
  2: {
    Icon: NewOnlineIcon,
    labelKey: 'user.launch',
  },
  3: {
    Icon: HotActiIcon,
    labelKey: 'user.activity',
  },
  4: {
    Icon: ImpNotiIcon,
    labelKey: 'user.announcement',
  },
};